import React from 'react';
import ReactDOM from 'react-dom/client';
import esriConfig from '@arcgis/core/config.js';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import 'antd/dist/antd.css';

esriConfig.apiKey = process.env.REACT_APP_ARCGIS_API_KEY;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
